/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(409);


/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* global $, ShopgateProductDetailsCore */$.shopgate=$.shopgate||{};/**
	 * This is a ShopgateProductDetailsCore sort plugin
	 * @param  {Object} _core Reference to the ShopgateProductDetailsCore
	 * @return {Object} An object with informations about the capabilities of this plugin
	 */var defaultSortPlugin=function defaultSortPlugin(_core,_coreOptions){/**
	   * This function cares about sorting product attribute values
	   * @param  {String} productAttributeName The name of the attribute whos values should be sorted
	   * @param  {Array} productAttributeValues A list of the available product attribute values
	   * @param  {Object} shopProperties Contains properties of the current shop {shopNumber, shopGroup}
	   * @return {Array} The sorted product attribute value list
	   */function _onProductAttributeSort(productAttributeName,productAttributeValues,shopProperties){var sort=typeof $.sgHelpers.sizeSort=='function'?$.sgHelpers.sizeSort:null;return productAttributeValues.sort(sort);}var hooks={vendor:'Shopgate',name:'Default sort plugin',product_attribute_names:['size','sizes','größe','grösse','groesse','größen','grössen','größenauswahl','groessen','rozmiar','taille','tailles','select your size','shirt size'],shop_groups:[],shop_numbers:[],type:['sort.attributes'],onProductAttributeSort:_onProductAttributeSort};return hooks;};if((typeof ShopgateProductDetailsCore==='undefined'?'undefined':_typeof(ShopgateProductDetailsCore))=='object'&&typeof ShopgateProductDetailsCore.registerPlugin=='function'){ShopgateProductDetailsCore.registerPlugin(defaultSortPlugin);}else{console.warn('No instance of "ShopgateProductDetailsCore" found');}

/***/ })

/******/ });


// WEBPACK FOOTER //
// 93e3498e9e1b1a354b85/lib/1.0/product_sort/default.js